<div class="tv-live-main-container">
    <div class="tv-live-header"></div>
    <div class="tv-live-item-list container"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="200"
        (scrolled)="getMore()"
        (scrolledUp)="getMore()">
        <div class="tv-live-item" *ngFor="let item of tvList">
            <div class="tv-live-cover">
                <a [routerLink]="['/play',item.key]" [queryParams]="{id: item.lastKey}" title="{{ item.title }}">
                    <img src="{{item.image | safeResource}}?w=280&h=280&format=jpg&mode=crop" />
                </a>
            </div>
            <div class="tv-live-title">
                <a [routerLink]="['/play',item.key]" [queryParams]="{id: item.lastKey}" title="{{ item.title }}">{{ item.title }}</a>
            </div>
        </div>
        <div class="tv-live-item flex-place-holder" *ngFor="let item of flexPlaceholder"></div>
    </div>
    <div class="text-center loading" *ngIf="isPending">
        <div class="centerload">
            <app-loader-spinner></app-loader-spinner>
        </div>
        <span>正在加载</span>
    </div>
    <!-- <div class="tv-live-bottom-line text-center" *ngIf="bottomLine && pageParams.page > 1">
        <span>我是有底线的</span>
    </div> -->
    <div class="tv-live-end text-center" *ngIf="!isPending">
        <span>功能测试中，更多频道将陆续添加！</span>
    </div>
</div>
<app-footer class="d-block"></app-footer>